var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display row"},[_c('div',{staticClass:"renewal-notice col-12"},[_c('p',[_vm._v(" Rhythm Readerは、リズム電卓としてリニューアルしました。 "),_c('a',{attrs:{"href":_vm.renewalUrl}},[_vm._v("新「リズム電卓」へ")])])]),_vm._l((_vm.canvasNum),function(num){return _c('canvasbox',{key:num,attrs:{"score":_vm.score,"boxnum":num}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }